<template>
  <div class="flex-row page">
    <img
      src="https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/6216dee45a7e3f031061d0f1/62a6ad333ff61e0011ec6d26/16550907004625911704.png"
      class="image"
    />
    <div class="flex-col group" @keydown.enter="LoginCheck">
      <span class="text">笑柚管理端</span>
      <div class="flex-row section_1">
        <el-input
          placeholder="请输入账号"
          type="text"
          clearable
          v-model.trim="userinfo.userName"
        >
          <template slot="prepend"> <i class="el-icon-user"></i></template>
        </el-input>
      </div>
      <div class="flex-col group_1">
        <div class="flex-row section_3">
          <el-input
            placeholder="请输入密码"
            type="password"
            show-password
            clearable
            v-model.trim="userinfo.passWord"
          >
            <template slot="prepend"> <i class="el-icon-unlock"></i></template>
          </el-input>
        </div>
        <el-button type="primary" class="section_5" @click="LoginCheck()"
          >登录</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import CryptoJS from 'crypto-js'; // 导入 crypto-js 库
import { aesEncrypt } from "@/utils/cryptoPwd";

export default {
  data() {
    return {
      userinfo: {
        userName: "",
        passWord: "",
      },
    };
  },
  mounted() {},
  methods: {
    LoginCheck() {
      var that     = this;
      var userinfo = this.userinfo;
      this.$message.closeAll();
      if (userinfo.userName == "") {
        this.$message.error("请输入账号");
        return;
      }
      if (userinfo.passWord == "") {
        this.$message.error("请输入密码");
        return;
      }
      this.$api
        .post("/api/Token/LoginAdmin", {
          userName: userinfo.userName,
          // password: CryptoJS.MD5(userinfo.passWord).toString(),
          password:aesEncrypt(userinfo.passWord),
          // password: userinfo.passWord,
        })
        .then((res) => {
          if (res.succeed) {
            this.$message.success("操作成功！");
            that.$store.commit("setToken", res.data.token);
            localStorage.setItem("token", res.data.token);
            that.$store.commit("setUserinfo", JSON.stringify({...res.data.user,adminType:res.data.glyType}));
            this.$router.push({ path: "/main/index" });
            this.$store.commit("setNavIndex", [0, 0]);
          } else {
            // this.$message.error(res.error);
          }
        });

      // that.login();
    },
    login() {
      var that = this;
      var loading = this.$loading({
        lock: true,
        text: "登录中...",
        background: "rgba(255, 255, 255, 0.7)",
      });
      this.$api
        .post(url, {
          account: that.userinfo.userName,
          pwd: that.userinfo.passWord,
        })
        .then((res) => {
          loading.close();
          if (res.succeed == true) {
            // that.$store.commit("setUserinfo", JSON.stringify(res.data));
            that.$store.commit("setUserinfo", JSON.stringify({...res.data.user,adminType:res.data.glyType}));
            that.$message.success("登录成功");
            this.$store.commit("setNavIndex", [0, 0]);
            this.$router.push({ path: "/main/index" });
          }
        })
        .catch(function () {
          loading.close();
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  padding: 0.52rem 1.08rem 0.51rem;
  background-color: rgb(255, 255, 255);
  width: 100%;
  overflow-y: auto;
  height: 100%;
  max-height: 100%;
  box-sizing: border-box;
  .image {
    width: 9.89rem;
  }
  .group {
    position: absolute;
    top: 48%;
    transform: translateY(-50%);
    right: 14%;
    width: 20%;
    .text {
      align-self: center;
      color: rgb(46, 155, 255);
      font-size: 0.32rem;
      font-family: Microsoft YaHei;
      font-weight: 700;
      line-height: 0.32rem;
    }
    >>> {
      .el-input-group__prepend {
        background: #fff;
      }
      .el-input__inner {
        height: 0.5rem;
        border-radius: 0.1rem;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
      .el-input-group__append,
      .el-input-group__prepend {
        border-radius: 0.1rem;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
    .section_1 {
      margin-right: 0.03rem;
      margin-top: 0.78rem;
      color: rgb(169, 164, 164);
      font-size: 0.16rem;
      font-family: Microsoft YaHei;
      line-height: 0.15rem;
      background-color: rgb(255, 255, 255);
      border-radius: 0.1rem;
      input {
        height: 0.5rem;
      }
    }
    .group_1 {
      margin-top: 0.34rem;

      .section_3 {
        margin-right: 0.04rem;
        color: rgb(169, 164, 164);
        font-size: 0.16rem;
        font-family: Microsoft YaHei;
        line-height: 0.15rem;
        background-color: rgb(255, 255, 255);
        border-radius: 0.1rem;
      }
      .section_5 {
        margin-top: 0.3rem;
        width: 50%;
        align-self: center;
        color: rgb(255, 255, 255);
        font-size: 0.18rem;
        font-family: Microsoft YaHei;
        line-height: 0.17rem;
        background-color: rgb(46, 155, 255);
        box-shadow: 0px 0.03rem 0.047rem 0.003rem rgba(40, 70, 146, 0.5);
        border-radius: 0.1rem;
        .text_5 {
          margin-left: 0.61rem;
        }
        .text_6 {
          margin-right: 0.5rem;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/login.vue